var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.result)?_c('v-progress-linear',{attrs:{"indeterminate":"","color":"primary","height":"6","rounded":""}}):_vm._e(),_vm._v(" "+_vm._s(_vm.result)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }